export default function handleInputChange(e) {
  const target = e.target;
  const value = target.type === 'checkbox' ? target.checked : target.value;
  const name = target.name;

  this.setState({
    [name]: value,
  });
}



// WEBPACK FOOTER //
// ./web/utils/handleInputChange.js